import { paginationKeys } from '@pro/pro-table/src/config/pagination'
import { tablePropsKeys } from '@pro/pro-table/src/config/table-props'
import { propsKeys as proTablePropsKeys } from '@pro/pro-table/src/config/props'
import { listPageTablePropsKeys } from './table-props'

const AllTablePropsKeys = [
  ...paginationKeys,
  ...tablePropsKeys,
  ...proTablePropsKeys,
  ...listPageTablePropsKeys
]

export default AllTablePropsKeys
